// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LsOVg","comment":"styles_comment__Ghau0"};